<template>
  <div class="procedimentos-saude">
    <div class="row">
      <PublicHeader :title="'Minha Saúde'">
        <div class="col-xs-12">
          <p>
            Aqui você acessa o seu histórico de atendimentos na Rede Municipal
            de Saúde de Santos. Também poderá acompanhar o agendamento de
            consultas de especialidades e exames.
          </p>
          <p>
            Caso não saiba o número do seu cartão SUS, você pode consultá-lo
            através do portal "Meu SUS Digital". Clique no logo abaixo para
            acessá-lo:
          </p>
          <a
            href="https://meususdigital.saude.gov.br/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              :src="require('../../../assets/css/img/conecte-sus.svg')"
              alt="Logo com o link do portal Meu SUS Digital"
              class="portal-govbr margem-bottom"
            />
            <span class="sr-only">Link para o portal Conecte SUS</span>
          </a>
          <p>
            Para mais informações, ligue na central de agendamento:
            0800-013-0013
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="row">
      <div class="container">
        <Breadcrumb :links="breadcrumb" />
        <div class="row">
          <div class="col-xs-12">
            <h3>
              O que você deseja?
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <div
              :class="[
                'form-group',
                { 'has-error': errors.has('filtro-cartao') }
              ]"
            >
              <label for="filtro-cartao" class="font-lg">
                Pesquisar meu histórico de saúde - Cartão SUS
              </label>
              <div class="input-group">
                <the-mask
                  id="filtro-cartao"
                  ref="filtro-cartao"
                  name="filtro-cartao"
                  placeholder="Digite o nº do seu cartão SUS..."
                  class="form-control"
                  data-vv-as="cartão SUS"
                  :mask="'###############'"
                  v-model="filtroCartao"
                  v-validate="'required|length:15'"
                />
                <span class="input-group-btn">
                  <button
                    class="btn btn-default btn-border"
                    @click="pesquisarPorCartao()"
                  >
                    <span class="sr-only"> Botão </span>
                    <font-awesome-icon :icon="'search'" />
                  </button>
                </span>
              </div>
              <input-error-message
                v-if="errors.has('filtro-cartao')"
                :message="errors.first('filtro-cartao')"
              />
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-xs-12 col-sm-6">
            <label for="lista-especialidades" class="font-lg">
              Ver a lista por especialidade
            </label>
            <font-awesome-icon
              v-if="loading.especialidades"
              :icon="'spinner'"
              class="font-lg"
              spin
            />
            <v-select
              v-else
              id="lista-especialidades"
              name="lista-especialidades"
              class="style-chooser"
              placeholder="-- Selecione uma Especialidade --"
              :options="especialidades"
              v-model="model.especialidade"
              @input="routeToPage('especialidade')"
            >
              <template slot="no-options">
                Nenhum resultado encontrado
              </template>
            </v-select>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-xs-12 col-sm-6">
            <label for="lista-exames" class="font-lg">
              Ver a lista por exames
            </label>
            <font-awesome-icon
              v-if="loading.exames"
              :icon="'spinner'"
              class="font-lg"
              spin
            />
            <v-select
              v-else
              id="lista-exames"
              name="lista-exames"
              class="style-chooser"
              placeholder="-- Selecione um Exame --"
              :options="exames"
              v-model="model.exame"
              @input="routeToPage('exame')"
            >
              <template slot="no-options">
                Nenhum resultado encontrado
              </template>
            </v-select>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 text-center">
            <h3>Estatísticas</h3>
          </div>
        </div>
        <EstatisticaTotalAgendamentos></EstatisticaTotalAgendamentos>
        <!-- <div class="row">
          <EstatisticaTempoMedio
            :apiUrl="`procedimentos-saude/exames/media-dias`"
            :title="`exames`"
          />
          <EstatisticaTempoMedio
            :apiUrl="`procedimentos-saude/especialidades/media-dias`"
            :title="`especialidades`"
          ></EstatisticaTempoMedio>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  PublicHeader,
  Breadcrumb,
  InputErrorMessage,
  EstatisticaTotalAgendamentos
  // EstatisticaTempoMedio
} from '../../../components'
import { request } from '../../../request'
import { TheMask } from 'vue-the-mask'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    TheMask,
    InputErrorMessage,
    EstatisticaTotalAgendamentos
    // EstatisticaTempoMedio
  },
  data() {
    return {
      conectSusSrc: require('../../../assets/css/img/conecte-sus.svg'),
      filtroCartao: '',
      especialidades: [],
      exames: [],
      model: {
        especialidade: '',
        exame: ''
      },
      loading: {
        especialidades: true,
        exames: true
      },
      breadcrumb: [
        {
          label: 'Minha Saúde'
        }
      ]
    }
  },
  created() {
    this.fetchDataBykey('especialidades')
    this.fetchDataBykey('exames')
  },
  methods: {
    routeToPage(page) {
      if (this.model[page]) {
        this.$router.push({
          name: `procedimentos_por_${page}`,
          params: {
            [page]: this.model[page]
          }
        })
      }
    },
    pesquisarPorCartao() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].$el.focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        this.$router.push({
          name: 'procedimentos_por_cartao',
          params: { cartao: this.filtroCartao }
        })
      })
    },
    fetchDataBykey(key) {
      this.loading[key] = true
      request
        .get(`procedimentos-saude/${key}`)
        .then(response => {
          const { data } = response
          this[key] = data
        })
        .catch(error => {
          const { response } = error
          console.log(response)
          this.$toastr.e(
            `Houve um errro ao carregar ${key}. Atualize a página e tente novamente`
          )
        })
        .finally(() => (this.loading[key] = false))
    }
  }
}
</script>

<style scoped>
label {
  display: block;
}

.portal-govbr {
  height: 70px;
  margin-top: 20px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-border {
  border: 1px solid #468c36;
}
</style>



// WEBPACK FOOTER //
// src/views/public/procedimentos_saude/index.vue